import React from 'react';
import { DayPicker } from 'react-day-picker';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';
import 'react-day-picker/dist/style.css';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Calendar wraps react-day-picker with our brand colours applied via CSS variables.
 * We intentionally do NOT override classNames — the built-in styles handle all
 * layout, grid, range highlighting, start/end circles, etc. correctly.
 * Brand colours are set once in index.css via --rdp-accent-color.
 */
function Calendar({ className, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('rdp-branded', className)}
      components={{
        IconLeft: () => <ChevronLeftIcon className="h-4 w-4 text-[#18216D]" />,
        IconRight: () => <ChevronRightIcon className="h-4 w-4 text-[#18216D]" />,
      }}
      {...props}
    />
  );
}

export { Calendar };
